// One fictional business shared by every preview fixture, so all pages tell the same story.
// None of this is real account data.
export const daysAgo = n => new Date(Date.now() - n * 86400000).toISOString();


export const daysAhead = n => new Date(Date.now() + n * 86400000).toISOString();

export const BUSINESS = 'Brightside Coffee';
export const LOCATIONS = [{
	locationId: 'loc-riverside',
	locationName: 'Riverside Plaza',
	city: 'Seattle',
	state: 'WA',
	storeCode: 'BC-101'
}, {
	locationId: 'loc-northgate',
	locationName: 'Northgate Center',
	city: 'Portland',
	state: 'OR',
	storeCode: 'BC-102'
}, {
	locationId: 'loc-harbour',
	locationName: 'Harbour Point',
	city: 'Tacoma',
	state: 'WA',
	storeCode: 'BC-103'
}, {
	locationId: 'loc-westfield',
	locationName: 'Westfield Row',
	city: 'Bend',
	state: 'OR',
	storeCode: 'BC-104'
}, {
	locationId: 'loc-elm',
	locationName: 'Elm & 4th',
	city: 'Everett',
	state: 'WA',
	storeCode: 'BC-105'
}];
export const PEOPLE = [{
	userId: 'user-dana',
	name: 'Dana Whitfield',
	email: 'dana@brightsidecoffee.com',
	role: 'Administrator'
}, {
	userId: 'user-marc',
	name: 'Marc Oyelaran',
	email: 'marc@brightsidecoffee.com',
	role: 'Store Manager'
}, {
	userId: 'user-priya',
	name: 'Priya Raman',
	email: 'priya@brightsidecoffee.com',
	role: 'Reviews Only'
}, {
	userId: 'user-tom',
	name: 'Tom Beckett',
	email: 'tom@brightsidecoffee.com',
	role: 'Read Only'
}, {
	userId: 'user-alia',
	name: 'Alia Nasser',
	email: 'alia@brightsidecoffee.com',
	role: 'Agency Partner'
}];
export const COMPETITORS = ['Marlow & Sons', 'Union Supply', 'Pike Provisions']; // Request body of an axios call. axios has already serialised it to a JSON string when it reaches the adapter.


export const requestBody = config => {
	const d = config && config.data;
	if (!d) return {};
	if (typeof d === 'object') return d;

	try {
		return JSON.parse(d);
	} catch (e) {
		return {};
	}
};

export const STREETS = {
	'loc-riverside': {
		street: '1420 Riverside Ave',
		zip: '98101',
		phone: '(206) 555-0141',
		googleId: 'accounts/1029384756/locations/5550001'
	},
	'loc-northgate': {
		street: '8805 N Northgate Blvd',
		zip: '97217',
		phone: '(503) 555-0172',
		googleId: 'accounts/1029384756/locations/5550002'
	},
	'loc-harbour': {
		street: '118 Harbour Point Blvd',
		zip: '98402',
		phone: '(253) 555-0115',
		googleId: 'accounts/1029384756/locations/5550003'
	},
	'loc-westfield': {
		street: '640 NW Westfield Row',
		zip: '97701',
		phone: '(541) 555-0190',
		googleId: 'accounts/1029384756/locations/5550004'
	},
	'loc-elm': {
		street: '2810 Elm St',
		zip: '98201',
		phone: '(425) 555-0136',
		googleId: 'accounts/1029384756/locations/5550005'
	}
};

export const addressOf = loc => ({
	addressLines: [STREETS[loc.locationId].street],
	locality: loc.city,
	administrativeArea: loc.state,
	postalCode: STREETS[loc.locationId].zip,
	regionCode: 'US',
	country: 'US'
});
